import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SaveButton from 'components/common/save-button';
import { TFunction } from 'i18next';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: any) => ({
  headerContainer: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottomColor: theme.accent.main,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
  },
  headerItem: { minWidth: 0 },
  saveWrapper: { '@media (hover: none) and (pointer: coarse)': { '& .MuiButton-root': { minHeight: 44 } } },
  headerTitle: {
    overflowWrap: 'anywhere',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

type HeaderProps = {
  t: TFunction;
  isValid: boolean;
  loading?: boolean
};

const Header = ({ t, isValid, loading }: HeaderProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.headerContainer}
    >
      <Grid item className={classes.headerItem}>
        <Typography variant="h5" className={classes.headerTitle}>
          {t('disclosure:projected-payments')}
        </Typography>
      </Grid>

      <Grid item className={clsx(classes.headerItem, classes.saveWrapper)}>
        <SaveButton
          disabled={!isValid}
          type="submit"
          loading={loading}
        />
      </Grid>
    </Grid>
  );
};

export default Header;
